<div class="o-grid {{ optionName }}-draggable-list-component">
    <div class="o-grid__row">
        @if (hasMultipleVisitSchedules) {
            <div class="o-grid__item cohort-header gap-medpace">
                @if (isEditGroupName) {
                    <div class="flex flex-row gap-medpace">
                        <div class="o-grid__row w-full">
                            <div class="o-grid__item">
                                <mds-text-field
                                    [formCtrl]="groupNameEditInput"
                                    id="GroupNameEditInput"
                                    appearance="outline"
                                    label="{{ 'Cohort/Group Name' }}"
                                    placeholder="Type here..."
                                ></mds-text-field>
                            </div>
                        </div>
                        <mds-icon-button
                            id="SubmitEditVisitGroupNameBtn"
                            [icon]="'done'"
                            (clickEvent)="doneChangeHeaderNameClickEvent()"
                            [tooltip]="'Submit'"
                            class="edit-button-width my-auto brand outline"
                        ></mds-icon-button>
                        <mds-icon-button
                            id="CancelVisitGroupNameBtn"
                            [icon]="'cancel'"
                            (clickEvent)="isEditGroupName = false"
                            [tooltip]="'Cancel'"
                            class="edit-button-width my-auto brand outline"
                        ></mds-icon-button>
                    </div>
                } @else {
                    <div class="o-grid__row m-auto">
                        @if (!isEditGroupName) {
                            <span class="draggable-list-header">{{ title }}</span>
                        }
                    </div>
                    <mds-icon-button
                        [icon]="'edit'"
                        (clickEvent)="editGroupNameClickEvent()"
                        [tooltip]="'Edit'"
                        class="edit-button-width brand outline"
                    ></mds-icon-button>
                }
                <mds-checkbox
                    class="m-auto"
                    [required]="false"
                    [disabled]="false"
                    [indeterminate]="false"
                    [label]="'Primary'"
                    [checked]="false"
                    (changeEvent)="isPrimaryOptionChange($event.checked)"
                    id="isPrimarycheckbox-{{ title }}"
                    [formCtrl]="isPrimaryControl"
                ></mds-checkbox>
            </div>
        }
    </div>

    <div cdkDropList id="{{ optionName }}List" class="c-bar-list" (cdkDropListDropped)="drop($event)">
        <!-- for each -->
        @for (option of options; track option) {
            <div cdkDrag>
                <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                <div class="o-grid__row">
                    <div class="o-grid__item option-row">
                        <div class="option width-90">
                            <div class="display-flex">
                                <div class="width-75">
                                    <mds-text-field
                                        id="input-{{ option.sortOrder }}"
                                        [formCtrl]="getFormControlText(optionsFormGroup, option)"
                                        appearance="outline"
                                        label="{{ capitalizeText(labelText) }}"
                                        placeholder="Type here..."
                                        (input)="optionChanged($event, option)"
                                    ></mds-text-field>
                                </div>
                                <div class="display-flex">
                                    <mds-checkbox
                                        [label]="'Scheduled'"
                                        [formCtrl]="getFormControlCheckbox(optionsFormGroup, option)"
                                        (changeEvent)="checkboxChanged($event.checked, option)"
                                        class="checkbox"
                                        id="checkbox-{{ option.sortOrder }}"
                                    ></mds-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="delete-icon width-10">
                            <mds-icon-button
                                [icon]="'delete'"
                                (clickEvent)="onOptionRemoveClick(option)"
                                [tooltip]="'Delete'"
                                class="danger outline"
                            ></mds-icon-button>
                        </div>
                    </div>
                </div>
            </div>
        }
        <!-- for each end  -->
    </div>
    <div class="o-grid__row">
        <div class="o-grid__field flex flex-row gap-medpace">
            <mds-button
                [id]="getButtonID(optionName)"
                variant="outline"
                color="primary"
                label="Add option"
                (clickEvent)="addOption()"
            ></mds-button>

            @if (hasMultipleVisitSchedules) {
                <mds-button
                    [id]="getRemoveButtonID(optionName)"
                    variant="outline"
                    label="Remove cohort/part"
                    color="warn"
                    (clickEvent)="tryToRemoveGroup()"
                ></mds-button>
            }
        </div>
    </div>

    @if (!optionsFormGroup?.valid && optionsFormGroup?.touched) {
        <div class="o-grid__row">
            <div class="o-grid__field">
                <medpace-alert [content]="getValidationMessage(optionsFormGroup)" [appearance]="'danger'" />
            </div>
        </div>
    }
</div>
